import React, { useEffect, useState } from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import Loading from 'components/commons/loading/Loading';
import ReactConfetti from 'react-confetti';

type Props = {
  hide: () => void;
  isShow: boolean;
  submit: () => Promise<{ tag: 'Success' | 'Error' }>;
  finish: () => void;
  updateGlobalTarget: (data: null) => void;
  updateConfirmGlobalTarget: (data: null) => void;
};

const Confetti = (): React.ReactElement => {
  return (
    <>
      <ReactConfetti
        {...{
          width: window.innerWidth,
          height: window.innerHeight,
          style: { zIndex: 9999 },
          gravity: 0.2,
          numberOfPieces: 1500,
          initialVelocityX: 13,
          initialVelocityY: 50,
          wind: 0,
          opacity: 70,
          recycle: false,
        }}
      />
    </>
  );
};

export const SavingsCompleteModal = ({
  hide: hide_,
  isShow,
  submit: submit_,
  finish,
  updateGlobalTarget,
  updateConfirmGlobalTarget,
}: Props): React.ReactElement => {
  const [state, setState] = useState<
    | { apiState: 'hitting' | 'failed' }
    | { apiState: 'hit'; isFinishing: boolean }
  >({ apiState: 'hitting' });
  const submit = async () => {
    setState({ apiState: 'hitting' });
    const result = await submit_();
    switch (result.tag) {
      case 'Success':
        setState({ apiState: 'hit', isFinishing: false });
        return;
      case 'Error':
        setState({ apiState: 'failed' });
        return;
    }
  };
  const hide = async (): Promise<void> => {
    hide_();
    if (state.apiState === 'hit') {
      setState({ apiState: 'hit', isFinishing: true });
      updateGlobalTarget(null);
      updateConfirmGlobalTarget(null);
      await finish();
    }
  };
  useEffect(() => {
    (async () => {
      if (isShow && state.apiState === 'hitting') {
        submit();
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow]);

  if (state.apiState === 'hit' && state.isFinishing)
    return <Loading loading style={{ marginTop: '3rem' }} />;

  return (
    <>
      {state.apiState === 'hit' && <Confetti />}
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-col text-bluegray-700">
            <div className="flex flex-row">
              <div
                className="icon-close ml-auto text-gray-500 cursor-pointer"
                onClick={hide}
              />
            </div>
            {((): React.ReactElement => {
              switch (state.apiState) {
                case 'hit':
                  return (
                    <>
                      <div className="font-bold text-bluegray-700 text-lg text-center">
                        お金の貯め方が決定しました
                        <br />
                        いよいよ資産運用のスタートです！
                      </div>
                      <img
                        src="/static/images/advisor/savings-complete.svg"
                        alt="目標設定完了"
                        className="mt-4 mx-auto"
                        width="310"
                        height="145"
                      />
                      <div className="mt-6 text-sm text-center">
                        これで設定は完了です。お疲れ様でした！
                        <br />
                        目標値やチャートが作成されたので
                        <br />
                        さっそく見てみましょう
                      </div>
                      <button
                        className="mt-8 p-2 text-bluegray-550 justify-center w-full text-base"
                        onClick={hide}>
                        閉じる
                      </button>
                    </>
                  );
                case 'failed':
                  return (
                    <>
                      送信に失敗しました
                      <button onClick={submit}>再試行する</button>
                    </>
                  );
                case 'hitting':
                  return (
                    <Loading
                      loading
                      circularLoading
                      style={{ padding: '12rem 3rem' }}
                    />
                  );
              }
            })()}
          </div>
        </div>
      </Modal2>
    </>
  );
};
